import React from "react";
import { Blocks } from "components/Blocks";
import { ProgramPageLayout } from "./ProgramPageLayout";

export const BlocksPage = ({ data, pages }) => (
  <ProgramPageLayout pages={pages}>
    <Blocks {...data} />
  </ProgramPageLayout>
);
